/* Only explicit vehicle-finder buttons open vehicle results. Category links keep their Shopify destinations. */
(function () {
  'use strict';
  const source = document.currentScript;
  const base = source?.dataset.jsdfBase;
  if (!base) return;
  const keys = ['make', 'year', 'model', 'engine', 'type', 'body'];
  function selection() {
    if (window.JSSVehicle) return window.JSSVehicle.get()?.values || {};
    const q = new URL(location.href).searchParams;
    let result = Object.fromEntries(keys.map(k => [k,q.get('jsdf_' + k) || '']));
    if (q.has('jsdf_make')) return result;
    try { result = JSON.parse(sessionStorage.getItem('jsdf-vehicle-v2') || '{}'); } catch (_) {}
    return result && typeof result === 'object' ? result : {};
  }
  function rewrite() {
    const vehicle = selection();
    const complete = keys.slice(0,4).every(k => typeof vehicle[k] === 'string' && vehicle[k]);
    const current = new URL(location.href);
    document.querySelectorAll('[data-menu-vehicle-selected]').forEach(selected => {
      const card = selected.closest('.jss-mega__finder-card');
      const hasVehicle = !!vehicle.make;
      selected.hidden = !hasVehicle;
      card.querySelectorAll('[data-menu-vehicle-empty]').forEach(node => { node.hidden = hasVehicle; });
      card.querySelector('[data-menu-vehicle-name]').textContent = ['make', 'year', 'model'].map(k => vehicle[k]).filter(Boolean).join(' ');
      const details = card.querySelector('[data-menu-vehicle-details]');
      details.textContent = ['engine', 'type', 'body'].map(k => vehicle[k]).filter(Boolean).join(' ');
      details.hidden = !details.textContent;
      const label = card.querySelector('[data-menu-vehicle-link-label]');
      if (!label.dataset.originalLabel) label.dataset.originalLabel = label.textContent;
      label.textContent = hasVehicle ? (complete ? 'Change vehicle' : 'Complete vehicle details') : label.dataset.originalLabel;
      card.querySelector('[data-menu-vehicle-reset]').hidden = !hasVehicle;
    });
    document.querySelectorAll('[data-jsdf-menu] a[href], a[data-jsdf-cta]').forEach(a => {
      const original = a.dataset.jsdfOriginal || a.getAttribute('href');
      let url; try { url = new URL(original, location.href); } catch (_) { return; }
      if (url.origin !== location.origin) return;
      const cta = a.hasAttribute('data-jsdf-cta');
      const preview = current.searchParams.get('preview_theme_id');
      if (!cta) {
        if (preview && !original.trim().startsWith('#')) url.searchParams.set('preview_theme_id', preview);
        a.href = original.trim().startsWith('#') ? original : url.href;
        return;
      }
      a.dataset.jsdfOriginal = original;
      const target = new URL(base, location.href);
      if (target.origin !== location.origin) return;
      target.searchParams.set('view', 'js-diesel-fitment');
      target.searchParams.set('jsdf_open', '1');
      keys.forEach(k => { if (typeof vehicle[k] === 'string' && vehicle[k]) target.searchParams.set('jsdf_' + k, vehicle[k]); });
      const record = window.JSSVehicle?.get();
      if (complete && keys.slice(0,4).every(k => record?.confirmedKeys.includes(k))) target.searchParams.set('jsdf_confirmed', '1');
      if (preview) target.searchParams.set('preview_theme_id',preview);
      a.href = target.href;
    });
    document.querySelectorAll('[data-jsdf-browse]').forEach(a => {
      const url = new URL(a.href, location.href);
      const preview = current.searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id',preview);
      a.href = url.href;
    });
  }
  document.addEventListener('click', event => {
    const reset = event.target.closest('[data-menu-vehicle-reset]');
    if (reset) {
      const link = reset.closest('.jss-mega__finder-card')?.querySelector('[data-jsdf-cta]');
      window.JSSVehicle?.clear();
      link?.focus({ preventScroll: true });
    }
  });
  document.addEventListener('shopify:section:load', rewrite);
  window.addEventListener('jss:vehicle-change', rewrite);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',rewrite); else rewrite();
})();
